<div class="TopModuleHead">
  <a href="javascript:void(0)" *ngIf="showBack" (click)="back()" class="topback"><span class="icon-back"></span>
    Back</a>
  <h6 class="mg-b10">
    <a [href]="'/courses/'+courseUrl.toLowerCase()"  target="_blank"
      class="font-14 navColor"><strong>{{headerData.courseTitle}}</strong>
      {{headerData?.moduleName ? '| '+ headerData?.moduleName : ''}}</a></h6>
  <h4 *ngIf="headerData?.title" class="heading24">{{headerData?.title}}</h4>
</div>
